import React, { useEffect, useState } from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import LinkTag from "../../molecules/link-tag";
import Headline from "../../atoms/headline";
import CardImage from "../../atoms/cardimage";
import DoubleRightIcon from "../../atoms/icons/double-angle-right";
import CustomStoryCard4 from "../../molecules/custom-story-card4";
import BigWithSmallStoryMobile from "../big-with-small-story-mobile";
import { Standard337x600Container } from "../../rows/ad-free";

import { getCollectionSlug } from "../../utils/utils";
import { getFitStories } from "../../helper/api";

import "./fourStoryWithAd.m.css";

const FourStoryWithAd = ({ collection, sections, fitUrl, pageType }) => {
  if (!(collection && collection.items)) {
    return null;
  }

  const [storiesArray, setStories] = useState(collection.items);
  const [isExternalStory, setExternalStory] = useState(false);
  const [externalSlug, setExternalSlug] = useState("");

  useEffect(() => {
    if (collection.template === "external-collection") {
      const slug = get(collection, ["metadata", "external-collection-slug"], "home");
      getFitStories(slug).then((data) => {
        setStories(data.items);
        setExternalSlug(`${fitUrl}`);
        setExternalStory(true);
      });
    }
  }, []);

  const stories = storiesArray
    .filter((item) => item.type === "story")
    .map((item) => item.story)
    .slice(0, 4);

  if (!(stories && stories.length)) {
    return null;
  }

  const [firstStory, secondStory, thirdStory, forthStory] = stories;

  return (
    <div styleName="wrapper" className="container" id={collection.slug}>
      <div styleName="content">
        <div styleName="headline">
          <LinkTag
            href={isExternalStory ? externalSlug : getCollectionSlug(collection, sections)}
            isExternalStory={isExternalStory}
          >
            <Headline text={collection.name || ""} headerType={6} />
          </LinkTag>
          {pageType === "home-page" && (
            <LinkTag
              href={isExternalStory ? externalSlug : getCollectionSlug(collection, sections)}
              isExternalStory={isExternalStory}
            >
              <DoubleRightIcon />
            </LinkTag>
          )}
        </div>
        <div styleName="row-1">
          <LinkTag href={firstStory.url} isExternalStory={isExternalStory}>
            <CardImage
              story={firstStory}
              aspectRatio={[16, 9]}
              imageType="image16x9"
              widths={[450]}
              eager={true}
              showHeadline={true}
              showStoryTypeIcon
            />
          </LinkTag>

          {secondStory && <CustomStoryCard4 story={secondStory} isExternalStory={isExternalStory} />}
        </div>

        <div styleName="row-2">
          {thirdStory ? <CustomStoryCard4 story={thirdStory} isExternalStory={isExternalStory} /> : null}

          {forthStory ? (
            <LinkTag href={forthStory.url} isExternalStory={isExternalStory}>
              <CardImage
                story={forthStory}
                aspectRatio={[16, 9]}
                imageType="image16x9"
                widths={[450]}
                eager={true}
                showHeadline={true}
                showStoryTypeIcon
              />
            </LinkTag>
          ) : null}
        </div>
      </div>

      <BigWithSmallStoryMobile
        collection={collection}
        externalStories={storiesArray}
        isExternalStory={isExternalStory}
        externalSlug={externalSlug}
      />

      <div styleName="ad">
        <Standard337x600Container id="home300x600" />
      </div>
    </div>
  );
};

FourStoryWithAd.propTypes = {
  collection: object.isRequired,
  sections: array,
  fitUrl: string,
  pageType: string,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  fitUrl: get(state, ["qt", "config", "publisher-attributes", "fit_page_url"], null),
  pageType: get(state, ["qt", "pageType"], null),
});

export default connect(mapStateToProps, null)(FourStoryWithAd);
